(function () {
  'use strict';
  var CM_RSK = window.CM_PDP_RESKIN || {};
  /* RETROFIT i18n (R11) : le separateur decimal des NOTES suit la langue de la
     page (« 4,7 » en fr/de/nl, « 4.7 » en anglais). Le pont porte la meme cle que
     `casemira-reassurance.liquid` et `casemira-trust-badge.liquid`. Repli codé. */
  var CM_SEP_DEC = (window.FoxTheme && FoxTheme.casemira && FoxTheme.casemira.fiche
    && FoxTheme.casemira.fiche.separateurDecimal) || ',';
  var SCARCITY = !!CM_RSK.scarcity;

  /* i18n R2b : table lue UNE fois, repli code (CONVENTION.md § 3). Deux
     chaines sont partagees avec le Liquid de la fiche et lisent donc la MEME
     cle des deux cotes (CONVENTION.md § 5) : la pastille du visualiseur
     (`snippets/casemira-visualiseur.liquid`) et « Format : … », que
     `assets/casemira-size-picker.js` repose de son cote. */
  var S = (window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.fiche) || {};
  /* i18n R15 : locale de la page, lue au pont puis, a defaut, sur <html lang>. Sert a
     n'armer les replis codes francais (telephone) que sur le site francais. */
  var CM_LOCALE = String(S.locale || (document.documentElement && document.documentElement.lang) || 'fr').toLowerCase();
  var CM_EST_FR = CM_LOCALE === 'fr' || CM_LOCALE.indexOf('fr-') === 0;

  function avec(modele, jeton, valeur) {
    return String(modele).split(jeton).join(valeur);
  }

  /* Sous Shopify Markets en sous-repertoires, un lien ecrit « /pages/… » sort
     du marche courant et perd la langue. Le prefixe ne suffit pas : Shopify
     traduit AUSSI le handle, et « /en/pages/avis-clients » ne repond qu'au prix
     d'une redirection 301. Vague R12 : l'adresse est resolue cote Liquid par
     `snippets/casemira-js-strings.liquid` (`pages['avis-clients'].url`), et le
     repli est exactement l'ancien calcul. */
  var AVIS_URL = ((window.FoxTheme && window.FoxTheme.casemira && window.FoxTheme.casemira.urls
                   && window.FoxTheme.casemira.urls.avis)
               || (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/')
                   + 'pages/avis-clients'));

  /* Titre : nom du modèle (après le dernier « - » / « – ») en italique gold */
  function titleItalic() {
    document.querySelectorAll('.section-main-product .product__title').forEach(function (el) {
      if (el.dataset.cmItalic) return;
      var txt = el.textContent.trim();
      var parts = txt.split(/\s[–-]\s/);
      if (parts.length > 1) {
        var name = parts[parts.length - 1];
        el.innerHTML = txt.slice(0, txt.length - name.length) + '<em class="cm-model">' + name + '</em>';
      }
      el.dataset.cmItalic = '1';
    });
  }

  var VIZ_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9V5a2 2 0 0 1 2-2h4M21 9V5a2 2 0 0 0-2-2h-4M3 15v4a2 2 0 0 0 2 2h4M21 15v4a2 2 0 0 1-2 2h-4"></path><circle cx="12" cy="12" r="2.5"></circle></svg>';

  /* Déclenche le visualiseur d'origine (masqué en CSS) */
  function triggerViz() {
    var real = document.querySelector('.cm-trigger[data-cm-open]') || document.querySelector('.cm-trigger');
    if (real) real.click();
  }

  /* CASEMIRA C1 vague 1 : le bouton pleine largeur de la colonne
     (.cm-viz-col-btn) a été SUPPRIMÉ, ainsi que le replacement spécifique au
     couloir qui allait avec. La pastille posée sur la photo est désormais le
     seul point d'entrée du visualiseur, desktop comme mobile (SPEC.md point 2).
     assets/casemira-visualiseur-facade.js écoute toujours .cm-viz-pill : le
     chargement paresseux de l'app n'est pas touché. */

  /* Pastille « Visualisez ce tapis chez vous » (260 x 54), posée en bas à gauche.
     En desktop elle vit DANS la photo héros : la galerie est une mosaïque, une
     pastille ancrée sur le conteneur se retrouverait au pied de toute la grille.
     En mobile elle reste sur le conteneur, qui est la fenêtre du carrousel :
     elle ne défile donc pas avec la photo. */
  function addVizPill() {
    var wrap = document.querySelector('.section-main-product .product__media-gallery-viewer-wrap');
    if (!wrap) return;
    var hero = wrap.querySelector('.product__media-item');
    var host = (window.innerWidth >= 768 && hero) ? hero : wrap;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var pill = document.querySelector('.section-main-product .cm-viz-pill');
    if (!pill) {
      pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'cm-viz-pill';
      pill.innerHTML = VIZ_ICON + '<span class="cm-viz-pill__label">' + (S.vizPastille || 'Visualisez ce tapis chez vous') + '</span>';
      pill.addEventListener('click', triggerViz);
    }
    if (pill.parentNode !== host) host.appendChild(pill);
  }

  /* Rareté « Plus que X en stock » sur les tuiles — algo identique à
     snippets/scarcity-stock.liquid (hash + cycle 14j + sweet-spot + max 2). */
  var CYCLE_DAYS=14, MAX_ROWS=2, RECT_SWEET_MIN=160, RECT_SWEET_MAX=250, RECT_MIN=160, ROUND_SWEET_MIN=120, ROUND_SWEET_MAX=200, ROUND_MIN=120;
  function hash(s){var h=5381;for(var i=0;i<s.length;i++){h=((h<<5)+h)+s.charCodeAt(i);h=h&h;}return Math.abs(h);}
  function daysSinceEpoch(){return Math.floor((new Date()-new Date(2025,0,1))/86400000);}
  function getVirtualStock(id){var d=daysSinceEpoch(),c=Math.floor(d/CYCLE_DAYS),dic=d%CYCLE_DAYS;var init=2+(hash(id+'-cycle-'+c)%3);var dec=Math.floor((init-1)*dic/(CYCLE_DAYS-1));var s=init-dec;return s<1?1:s;}
  function parseSize(t){if(!t)return{dim:0,isRound:false};var r=/ø/i.test(t);var c=t.replace(/ø/gi,'').replace(/cm/gi,'').trim();var m=c.match(/(\d+)/);return{dim:m?parseInt(m[1],10):0,isRound:r};}
  function elig(b){if(b.classList.contains('is-unavailable'))return false;var i=parseSize(b.getAttribute('data-size-value')||'');return i.isRound?i.dim>=ROUND_MIN:i.dim>=RECT_MIN;}
  function prio(dim,isR){if(isR)return(dim>=ROUND_SWEET_MIN&&dim<=ROUND_SWEET_MAX)?0:1;return(dim>=RECT_SWEET_MIN&&dim<=RECT_SWEET_MAX)?0:1;}
  function scarcity(){
    if(!SCARCITY) return;
    var cont=document.querySelector('.section-main-product .dimension-picker-container[data-product-id]');
    if(!cont || cont.getAttribute('data-cm-scar')) return;
    var list=[];
    cont.querySelectorAll('.dimension-btn[data-variant-id]').forEach(function(b){if(elig(b)){var i=parseSize(b.getAttribute('data-size-value')||'');list.push({b:b,dim:i.dim,p:prio(i.dim,i.isRound)});}});
    list.sort(function(a,c){return a.p!==c.p?a.p-c.p:a.dim-c.dim;});
    for(var k=0;k<list.length&&k<MAX_ROWS;k++){var b=list[k].b,st=getVirtualStock(b.getAttribute('data-variant-id'));var s=b.querySelector('.dimension-btn__stock');if(s){s.innerHTML='Plus que <strong>'+st+'</strong> en stock';b.classList.add('has-scarcity');}}
    cont.setAttribute('data-cm-scar','1');
  }

  /* C1 vague 5, point 4 : `badgesRail()` a été supprimée, comme `colorRail()`
     l'avait été en vague 4, et pour la même raison.
     Elle posait `is-scrollable` / `is-scrolled-end` sur la rangée de badges pour
     que le fondu de droite de la bande défilante ne mente jamais. La bande
     n'existe plus : sous 1000 px, la rangée est une mise en page qui montre
     tous les badges d'un coup (1 ou 2 en ligne, 3 en trois colonnes, 4 en
     grille 2 x 2 ; assets/casemira-badges.css). Il n'y a donc plus ni
     défilement à mesurer, ni masque à faire mentir, et aucun remplacement :
     c'est le CSS seul qui décide, à partir de `data-count`.
     Le comportement des badges explicatifs vit dans son propre fichier,
     assets/casemira-badges.js, chargé par le snippet des badges. */

  /* C1 vague 4, point 5 : `colorRail()` a été supprimée.
     Elle posait `is-scrollable` / `is-scrolled-end` sur la rangée de coloris et
     ramenait la pastille active dans la bande. La rangée ne défile plus : elle
     revient à la ligne (assets/casemira-pdp-reskin.css), toutes les pastilles
     sont visibles, il n'y a donc plus d'état à mesurer ni de fondu à faire
     mentir. Aucun remplacement : c'est le CSS seul qui décide. */

  /* Affiche la forme active (Rectangle…) à droite du label « Forme » */
  function formeValue() {
    var head = document.querySelector('.section-main-product .forme-selector__heading');
    if (!head) return;
    var active = document.querySelector('.section-main-product .forme-option--active .forme-option__label');
    var val = active ? active.textContent.trim() : '';
    if (!val) return;
    var span = head.querySelector('.cm-forme-value');
    if (!span) { span = document.createElement('span'); span.className = 'cm-forme-value'; head.appendChild(span); }
    /* ★ C1 VAGUE 10, point 2 : ON N'ECRIT QUE SI LA VALEUR A CHANGE.
       `textContent = val` remplace le nœud texte MEME quand la valeur est
       identique. C'est une mutation, l'observateur de fin de fichier la voit,
       il rappelle applyAll() 80 ms plus tard, qui reecrit, qui remute : la
       boucle se nourrissait elle-meme. Mesure du 22/08, page au repos, 5 s
       d'observation : 60 remplacements de ce nœud et 60 de `.cm-price-format`,
       soit 12 tours d'applyAll par seconde, indefiniment, sur toute fiche.
       Voir aussi le `takeRecords()` en fin de fichier. */
    if (span.textContent !== val) span.textContent = val;
  }

  /* C1 vague 3, point E9 : le compteur « 1 / 13 » devient une rangée de points,
     façon Sklum, en bas à droite de la photo. Sept points visibles au plus ;
     au-delà, la piste glisse d'un pas par photo et les points de bord se
     réduisent : le même signal de « il y en a d'autres » que sur un carrousel
     d'application, sans chiffre à lire. Le style est dans
     assets/casemira-pdp-layout.css (section 7) ; ici, seulement l'état.
     La pastille du visualiseur reste en bas à gauche : les deux ne se croisent
     jamais, même sur un écran de 390 px. */
  var DOTS_WINDOW = 7;
  var galViewer = null, galObs = null;
  function galleryDots() {
    var wrap = document.querySelector('.section-main-product .product__media-gallery-viewer-wrap');
    if (!wrap) return;
    var viewer = wrap.querySelector('.product__media-gallery-viewer');
    if (!viewer) return;
    function upd() {
      var slides = viewer.querySelectorAll('.product__media-item:not(.swiper-slide-duplicate)');
      var total = slides.length; if (!total) return;
      var active = viewer.querySelector('.swiper-slide-active');
      var idx = (active && active.getAttribute('data-media-index') != null)
              ? parseInt(active.getAttribute('data-media-index'), 10) : 0;
      if (isNaN(idx) || idx < 0) idx = 0;
      if (idx > total - 1) idx = total - 1;

      var box = wrap.querySelector('.cm-gallery-dots');
      if (!box) {
        box = document.createElement('div');
        box.className = 'cm-gallery-dots';
        /* Repère purement visuel : le balayage et PhotoSwipe portent déjà
           l'information pour les lecteurs d'écran (#GalleryStatus). */
        box.setAttribute('aria-hidden', 'true');
        box.appendChild(document.createElement('div')).className = 'cm-gallery-dots__track';
        wrap.appendChild(box);
      }
      var track = box.firstElementChild;
      if (track.childElementCount !== total) {
        var html = '';
        for (var i = 0; i < total; i++) html += '<span class="cm-gallery-dots__dot"></span>';
        track.innerHTML = html;
      }

      /* Fenêtre glissante : le point actif reste au milieu tant qu'il y a de
         quoi glisser des deux côtés. */
      var offset = 0;
      if (total > DOTS_WINDOW) {
        offset = Math.min(Math.max(idx - 3, 0), total - DOTS_WINDOW);
      }
      box.style.setProperty('--cm-dot-offset', offset);
      /* ★ C1 vague 7, point 6 : la largeur de la pastille est un CALCUL, écrit
         une seule fois dans assets/casemira-pdp-layout.css. Ici on ne pose que
         le nombre de points visibles. Sept au plus ; moins que sept, la
         pastille se resserre plutôt que de laisser du vide à droite de la
         dernière photo. La largeur ne bouge pas pendant le glissement : la
         fenêtre contient toujours exactement un point actif, donc toujours la
         même somme de largeurs. */
      box.style.setProperty('--cm-dot-n', Math.min(total, DOTS_WINDOW));
      box.style.width = '';

      var dots = track.children;
      for (var j = 0; j < dots.length; j++) {
        var cls = 'cm-gallery-dots__dot';
        if (j === idx) cls += ' cm-gallery-dots__dot--active';
        if ((j === offset && offset > 0) || (j === offset + DOTS_WINDOW - 1 && offset + DOTS_WINDOW < total)) {
          cls += ' cm-gallery-dots__dot--edge';
        }
        if (dots[j].className !== cls) dots[j].className = cls;
      }
    }
    upd();
    if (viewer !== galViewer && window.MutationObserver) {
      if (galObs) galObs.disconnect();
      galViewer = viewer;
      /* ★ C1 vague 7, point 6 : plus de débounce de 50 ms. Swiper pose
         `swiper-slide-active` au DÉBUT de la transition de glissement ; en
         attendant 50 ms, le trait actif partait après le doigt, et sur un
         balayage rapide il rattrapait son retard d'un coup, ce qui est
         exactement le saut que le propriétaire décrit. Un `requestAnimationFrame`
         cale la mise à jour sur le prochain rendu du navigateur : le trait part
         dans la même image que la photo, et une rafale de mutations ne provoque
         toujours qu'un seul recalcul. */
      var rafPending = false;
      galObs = new MutationObserver(function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () { rafPending = false; upd(); });
      });
      galObs.observe(viewer, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  /* Réassurance : remplace le bloc par la version exacte de la maquette
     (tpl 161-167) — 3 lignes, icônes navy en cercle, textes complets, sans popover. */
  function reassurance() {
    var cont = document.querySelector('.section-main-product .rea-pdp-container');
    if (!cont || cont.getAttribute('data-cm-rea')) return;
    cont.setAttribute('data-cm-rea', '1');
    cont.style.cssText = 'display:flex;flex-direction:column;gap:18px;border-top:1px solid #e8e4de;padding-top:22px;';
    function row(svg, title, sub, href) {
      var inner = '<span style="width:38px;height:38px;border-radius:50%;background:#f1efea;color:#0f1e2e;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' + svg + '</span>'
        + '<span><span style="display:block;font-size:14px;font-weight:600;color:#0f1e2e;">' + title + '</span>'
        + '<span style="display:block;font-size:12.5px;color:#6f7682;margin-top:2px;">' + sub + '</span></span>';
      if (href) {
        return '<a href="' + href + '" style="display:flex;align-items:flex-start;gap:13px;text-decoration:none;color:inherit;cursor:pointer;">' + inner + '</a>';
      }
      return '<div style="display:flex;align-items:flex-start;gap:13px;">' + inner + '</div>';
    }
    /* G18g (07/09/2026) : la fleche de retour est celle de
       `snippets/casemira-icone-retour.liquid`, elle-meme recopiee du pied de
       page de la home. Elle etait ici la troisieme variante du meme dessin.
       Le trace est en dur parce que ce fichier est un asset : la seule chose
       qui garantit l'identite est de le recopier au caractere pres, et le
       snippet est la reference a relire si un jour il bouge. */
    var ic1 = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9a8 8 0 1 1-1.2 4.2"></path><path d="M4 4v5h5"></path></svg>';
    var ic2 = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5.5" width="18" height="13" rx="2"></rect><path d="M3 10h18"></path><path d="M6.5 14.5h3"></path></svg>';
    var ic3 = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h3l1.6 4-2 1.2c.9 1.9 2.5 3.5 4.4 4.4l1.2-2 4 1.6V17a2 2 0 0 1-2.2 2A14.5 14.5 0 0 1 4.8 6.2 2 2 0 0 1 5 4z"></path></svg>';
    cont.innerHTML =
        /* G18g : le repli code suit les nouvelles cles (titre avec le delai,
         sous-ligne sur la gratuite du renvoi). Il ne sert que si le pont de
         chaines n'a pas ete rendu. */
      row(ic1, S.reaSatisfaitTitre || 'Satisfait ou remboursé 30 jours',
                 S.reaSatisfaitDetail || 'Retour 100 % gratuit')
      /* 18/09/2026 : en France, la reassurance dit la MEME chose que la ligne
         de prix juste au-dessus, Klarna 3x ET PayPal 4x. `reaPfTitre` et
         `reaPfDetail` ne sont publies par `casemira-js-strings.liquid` que
         lorsque `localization.country.iso_code` vaut FR : leur simple presence
         est le signal, aucun pays n'est teste ici. Hors de France, les deux
         valent `undefined` et la ligne Klarna d'origine sort inchangee. */
      + row(ic2, S.reaPfTitre  || S.reaKlarnaTitre  || 'Paiement 3× sans frais',
                 S.reaPfDetail || S.reaKlarnaDetail || 'En 3 mensualités identiques avec Klarna')
      /* i18n R5f : le telephone n'est promis que sur le site francais. Le titre, le
         detail et le lien viennent du pont, qui les bascule sur l'email hors locale fr.
         Le repli code reste le francais, comme partout ailleurs.
         i18n R5h : le PICTOGRAMME aussi. `ic3` est un combine ; hors francais, le pont
         publie une enveloppe dans `reaServiceIcone`. En locale fr le pont ne publie
         rien : le repli `ic3` s'applique et le rendu francais est inchange. */
      /* i18n R15 : le repli code lui-meme est francais. Si le pont ne publie rien sur
         une page /de ou /nl, le numero francais sortait quand meme. Le repli telephone
         n'est donc arme qu'en locale fr ; ailleurs le detail et le lien restent vides,
         et `row` rend alors une ligne sans ancre. */
      + row(S.reaServiceIcone || ic3, S.reaServiceTitre || 'Service client français',
                 S.reaServiceDetail || (CM_EST_FR ? '02 59 66 01 35 · 6j/7, 8h–20h' : ''),
                 S.reaServiceHref || (CM_EST_FR ? 'tel:+33259660135' : ''));
  }

  /* C1 vague 3, point C4 : la réassurance COURTE de la vague 1 (« Retours
     gratuits 30 j · Paiement 3x sans frais · Service client français 6j/7 »)
     a été SUPPRIMÉE. Elle répétait mot pour mot le bandeau horizontal qui reste
     plus bas dans la colonne (reassurance(), juste au-dessus) : deux fois la
     même promesse à trente pixels d'écart. La règle CSS `.cm-rea-short` reste,
     pour les pages encore en cache. */

  /* Bloc avis « style Trustpilot » : reproduit la structure exacte de la
     maquette (tpl 168-190) — Excellent + 5 étoiles vertes carrées (dernière
     partielle pour 4,69) + « 468 avis · 4,69 sur 5 ». SANS logo Trustpilot,
     on garde le ⓘ existant (hors du lien). */
  function trustBox() {
    var bar = document.querySelector('.section-main-product .ctb.ctb--bar');
    var link = bar ? bar.querySelector('.ctb-bar-link') : null;
    if (!link || link.getAttribute('data-cm-tp')) return;
    link.setAttribute('data-cm-tp', '1');
    var sv = '<svg width="13" height="13" viewBox="0 0 24 24" fill="#fff"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"></path></svg>';
    function star() { return '<span style="width:19px;height:19px;background:#00b67a;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' + sv + '</span>'; }
    var partial = '<span style="width:19px;height:19px;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;flex-shrink:0;">'
      + '<span style="position:absolute;inset:0 30% 0 0;background:#00b67a;"></span>'
      + '<span style="position:absolute;inset:0 0 0 70%;background:#dcdce6;"></span>'
      + '<span style="position:relative;display:flex;">' + sv + '</span></span>';
    link.innerHTML =
      '<span style="display:flex;align-items:center;gap:6px;margin-bottom:6px;">'
        + '<span style="font-size:13.5px;font-weight:700;color:#0f1e2e;">' + (S.tpExcellent || 'Excellent') + '</span>'
        + '<span style="display:flex;gap:2px;">' + star() + star() + star() + star() + partial + '</span>'
      + '</span>'
      + '<span style="font-size:12px;color:#6f7682;">'
        + avec(avec(S.tpAvisSurCinq || '[n] avis · [note] sur 5', '[n]', STORE_CNT),
               '[note]', '<strong style="color:#0f1e2e;">' + String(STORE_AVG).replace('.', CM_SEP_DEC) + '</strong>')
      + '</span>';
    /* ⓘ glyph (pixélisé) → SVG propre */
    var infoBtn = bar ? bar.querySelector('.ctb-info') : null;
    if (infoBtn && !infoBtn.dataset.cmInfo) {
      infoBtn.dataset.cmInfo = '1';
      infoBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 11.5v4.5"></path><circle cx="12" cy="7.8" r="0.6" fill="currentColor" stroke="none"></circle></svg>';
    }
  }

  /* Supprime l'accordéon « Dimensions » (redondant : son contenu est
     désormais accessible via le lien « Guide des tailles » → modal). */
  function hideDimAccordion() {
    var scope = document.querySelector('.section-main-product') || document;
    scope.querySelectorAll('.product__block--collapsible_tab').forEach(function (blk) {
      if (blk.dataset.cmDimHidden) return;
      var h = blk.querySelector('.accordion-details__summary h2, .accordion-details__summary h4, .accordion-details__summary .h4');
      if (h && (h.textContent.trim().toLowerCase() === 'dimensions' || h.textContent.trim().toLowerCase() === String(S.dimensions || '').toLowerCase())) {
        blk.style.display = 'none';
        blk.dataset.cmDimHidden = '1';
      }
    });
  }

  /* Modal « Guide des tailles » (le markup vit hors de product-info → persistant) */
  var cmGuideLastFocus = null;
  function cmGuideFocusables(md) {
    return Array.prototype.slice.call(md.querySelectorAll(
      'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }
  function openGuide() {
    var ov = document.getElementById('cm-guide-overlay'), md = document.getElementById('cm-guide-modal');
    if (!md) return;
    /* a11y : on mémorise le déclencheur pour rendre le focus à la fermeture */
    cmGuideLastFocus = document.activeElement;
    if (ov) ov.classList.add('is-open');
    md.classList.add('is-open');
    /* verrouillage compatible iOS : position:fixed (overflow:hidden seul ne bloque pas le scroll tactile iPhone) */
    var y = window.scrollY || window.pageYOffset || 0;
    document.body.setAttribute('data-cm-scroll', y);
    document.body.style.top = (-y) + 'px';
    document.body.classList.add('cm-guide-locked');
    /* a11y : focus clavier envoyé dans la modale (sur la croix) */
    var cb = md.querySelector('.cm-guide-modal__close');
    if (cb) { try { setTimeout(function () { cb.focus(); }, 40); } catch (e) {} }
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }
  function closeGuide() {
    var ov = document.getElementById('cm-guide-overlay'), md = document.getElementById('cm-guide-modal');
    if (ov) ov.classList.remove('is-open');
    if (md) md.classList.remove('is-open');
    document.body.classList.remove('cm-guide-locked');
    /* restaure la position de défilement */
    var y = parseInt(document.body.getAttribute('data-cm-scroll') || '0', 10);
    document.body.style.top = '';
    document.body.removeAttribute('data-cm-scroll');
    if (y) window.scrollTo(0, y);
    /* a11y : on rend le focus au bouton « Guide des tailles » d'origine */
    if (cmGuideLastFocus && cmGuideLastFocus.focus) { try { cmGuideLastFocus.focus(); } catch (e) {} }
    cmGuideLastFocus = null;
  }
  if (!window.__cmGuideBound) {
    window.__cmGuideBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.cm-guide-trigger')) { e.preventDefault(); openGuide(); return; }
      if (e.target.closest && (e.target.closest('.cm-guide-modal__close') || e.target.id === 'cm-guide-overlay')) { closeGuide(); }
    });
    document.addEventListener('keydown', function (e) {
      var md = document.getElementById('cm-guide-modal');
      if (!md || !md.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeGuide(); return; }
      /* a11y : piège le focus clavier à l'intérieur de la modale (Tab / Shift+Tab) */
      if (e.key === 'Tab') {
        var f = cmGuideFocusables(md);
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1], a = document.activeElement;
        if (e.shiftKey && (a === first || !md.contains(a))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (a === last || !md.contains(a))) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* Affiche « Format : <taille sélectionnée> cm » à côté du prix (maquette tpl 85-88).

     C1 vague 3, point A1 : le libellé ne suivait pas le changement de format.
     Deux causes, toutes deux corrigées ici.
     1. product-info.js réécrit `#price-<section>.innerHTML` à chaque variante :
        le `<span class="cm-price-format">` posé dedans disparaît. Il est
        reposé, mais 80 ms plus tard, par l'observateur en fin de fichier. On
        rejoue donc aussi sur `variant:changed`, dans le même tour d'événement.
     2. Il lisait `.dw-picker__trigger-dim`, l'état FERMÉ du tiroir, qui, en
        pastilles à plat, n'est jamais mis à jour puisqu'il n'existe pas à
        l'écran. La source est désormais `input[name="id"]`, ce qui part
        réellement au panier, résolu en ligne du sélecteur.
     Aucune dépendance à l'ordre de chargement des scripts : on ne suppose pas
     que casemira-size-picker.js est déjà passé. */
  function selectedSizeText(scope) {
    var input = scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    var id = input && input.value ? String(input.value) : '';
    if (id) {
      var row = scope.querySelector('.dw-picker__row[data-variant-id="' + id + '"]')
             || scope.querySelector('.dimension-btn[data-variant-id="' + id + '"]');
      if (row) {
        var raw = row.getAttribute('data-size-value') || '';
        if (raw) return raw.replace(/(\d)\s*[xX]\s*(\d)/g, '$1 × $2').replace(/\s*cm\b/i, ' cm').trim();
      }
    }
    var el = scope.querySelector('.dw-picker__row--active .dw-picker__row-dim')
          || scope.querySelector('.dw-picker__trigger-dim')
          || scope.querySelector('.dimension-btn.is-selected .dimension-btn__size');
    return el ? el.textContent.trim() : '';
  }

  function priceFormat() {
    var scope = document.querySelector('.section-main-product');
    if (!scope) return;
    var pc = scope.querySelector('.product__block--price [id^="price-"]');
    if (!pc) return;
    var size = selectedSizeText(scope);
    if (!size) return;
    if (!/cm\s*$/i.test(size)) { size += ' cm'; }   /* le titre variante peut déjà contenir « cm » */
    var fmt = pc.querySelector('.cm-price-format');
    if (!fmt) { fmt = document.createElement('span'); fmt.className = 'cm-price-format'; pc.appendChild(fmt); }
    /* ★ C1 VAGUE 10, point 2 : meme raison que dans formeValue().
       `innerHTML = …` detruit et recree les enfants a chaque appel, meme pour
       la meme phrase. On compare d'abord. */
    var html = avec(S.formatLabel || 'Format : [t]', '[t]', '<strong>' + size + '</strong>');
    if (fmt.innerHTML !== html) fmt.innerHTML = html;
  }

  /* Avis produit au-dessus du titre (maquette). Lit les données Judge.me
     server-rendered (.jdgm-prev-badge). Si 0 avis produit → fallback note
     boutique. Le badge Judge.me natif est masqué (CSS). */
  var CFG0 = window.CM_PDP_RESKIN || {};
  var STORE_AVG = CFG0.storeAvg || 4.7, STORE_CNT = CFG0.storeCnt || 468; /* 21/08 : chiffres boutique lus en direct (métachamps Judge.me) via casemira-avis-stats */
  /* Compteur d'avis PRODUIT rendu côté serveur (metafield Judge.me, même
     source que le schema aggregateRating). Nécessaire car le badge DOM
     (.jdgm-prev-badge, app block) arrive APRÈS le bloc titre dans le HTML :
     un applyAll déclenché par l'observer pendant le streaming ne le voyait
     pas → fallback boutique inséré à tort, puis figé par le garde
     anti-doublon. Le badge DOM ne sert plus que de repli si le metafield
     n'est pas encore synchronisé.
     05/09 (tâche 6) : ce repli DOM ne trouve plus rien sur une fiche, le bloc
     app `preview_badge` ayant été retiré des gabarits produit avec le widget.
     Il est laissé en place, sans effet, pour que le retour arrière n'ait à
     toucher qu'aux gabarits. Le métachamp reste la seule source utile. */
  var PRODUCT_CNT = CM_RSK.cnt;
  var PRODUCT_AVG = CM_RSK.avg;
  /* LE BLOC AVIS EXISTE-T-IL SUR CETTE PAGE ? (G20, 08/09)
     ----------------------------------------------------------------------
     Depuis G20, `sections/casemira-avis-produit.liquid` ne rend RIEN quand le
     produit n'a aucun avis a lui : ni titre, ni repli, ni ancre `#cm-avis`.
     Le compteur ci-dessus, lui, vient du metachamp Judge.me, PAS de la meme
     source que le bloc (`casemira.avis_<langue>`, pose sur 184 fiches). Une
     fiche peut donc compter des avis en haut sans porter le bloc en bas, et
     `href="#cm-avis"` y serait un lien mort. Le drapeau est calcule cote
     Liquid par `snippets/casemira-pdp-reskin.liquid`, avec le calcul exact de
     la section. Sans drapeau (vieux HTML en cache), on retombe sur le
     compteur : c'est le comportement d'avant G20. */
  var BLOC_AVIS = (CM_RSK.blocAvis === undefined) ? (PRODUCT_CNT > 0) : !!CM_RSK.blocAvis;

  /* UNE NOTE, UN SEUL ARRONDI, SUR TOUTE LA FICHE.
     `(4.55).toFixed(1)` rend « 4.5 » : le nombre binaire le plus proche de 4,55
     est très légèrement en dessous, et toFixed arrondit ce qu'il a réellement,
     pas ce qui est écrit. Le bloc avis, lui, arrondit en Liquid (`round: 1`) et
     affiche « 4,6 ». La fiche annonçait donc deux notes différentes à trente
     centimètres d'écart, relevé du 05/09 sur le camden : 4,5 en haut, 4,6 dans
     le bloc. Le schema.org `aggregateRating` (FIX-6) porte la valeur BRUTE,
     4.55, et c'est ce qu'il doit faire : Google veut la valeur exacte, pas son
     affichage. Ce sont les deux affichages qui devaient s'accorder.
     `Math.round(x * 10) / 10` est l'arrondi demi-supérieur, celui de Liquid.

     Le séparateur vient de la locale, comme dans les cartes produit
     (`casemira.avis.separateur_decimal`, déjà exposé par
     `casemira-js-strings.liquid` l.150) : « 4,6 » en français, « 4.6 » en
     anglais. La virgule était écrite en dur, y compris sur /en. */
  var SEP_DEC = S.separateurDecimal || ',';
  function note1(x) {
    var n = Math.round((Number(x) || 0) * 10) / 10;
    return n.toFixed(1).replace('.', SEP_DEC);
  }
  function reviewRating() {
    var scope = document.querySelector('.section-main-product');
    if (!scope) return;
    var titleBlock = scope.querySelector('.product__block--title');
    if (!titleBlock || !titleBlock.parentNode) return;
    if (scope.querySelector('.cm-rating')) return;
    var badge = scope.querySelector('.jdgm-prev-badge');
    var cnt = PRODUCT_CNT || (badge ? parseInt(badge.getAttribute('data-number-of-reviews') || '0', 10) : 0);
    var avg = PRODUCT_AVG || (badge ? parseFloat(badge.getAttribute('data-average-rating') || '0') : 0);
    var isProduct = cnt > 0;
    var star = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.8 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"></path></svg>';
    var stars = ''; for (var i = 0; i < 5; i++) stars += star;
    var el = document.createElement('div');
    el.className = 'cm-rating';

    if (isProduct) {
      /* Avis PRODUIT : étoiles or + « N avis produit » → ancre vers le bloc avis.
         05/09 (tâche 6) : la cible n'est plus le conteneur Judge.me
         (#judgeme_product_reviews / .jdgm-rev-widg), qui a quitté les fiches avec
         le widget. C'est désormais `#cm-avis`, l'ancre de la section maison
         `casemira-avis-produit`. Le `href` est écrit dans le HTML : sans JS, ou
         si le script casse, le lien marche quand même, et la marge sous
         l'en-tête collant vient du `scroll-margin-top` de `.cma`. La DOUCEUR du
         saut, elle, est ajoutée par `ancreDouce()` plus bas, sur ce lien
         seulement. Elle n'est PAS posée en CSS : `scroll-behavior: smooth` sur
         `html` est global et ferait glisser la page à chaque restauration de
         position par `window.scrollTo` (sélecteur de taille mobile, guide des
         tailles, popup, barre du haut). */
      /* G20 : l'ancre n'est posee que si le bloc est vraiment la. Sinon le
         meme libelle mene a la page avis, qui, elle, existe toujours. */
      var cible = BLOC_AVIS ? '#cm-avis' : AVIS_URL;
      el.innerHTML = '<span class="cm-rating__stars">' + stars + '</span>'
        + '<span class="cm-rating__value">' + note1(avg) + '</span>'
        + '<a class="cm-rating__link" href="' + cible + '">' + avec((cnt === 1 ? S.avisProduitUn : S.avisProduit) || S.avisProduit || '[n] avis produit', '[n]', cnt) + '</a>';
    } else {
      /* FALLBACK (0 avis produit) : note BOUTIQUE, même format inline que les
         avis produit mais libellé « avis boutique » + ⓘ pour distinguer.
         On masque le bloc Trustpilot du bas (pas de doublon). */
      el.className = 'cm-rating cm-rating--store';
      var infoSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 11.5v4.5"></path><circle cx="12" cy="7.8" r="0.6" fill="currentColor" stroke="none"></circle></svg>';
      var tipTxt = S.noteTransparence || 'Note basée sur les retours publiés par des acheteurs ayant testé ces mêmes tapis chez nos partenaires fabricants européens. Tous les retours sont publiés sans tri ; ces avis ne sont pas vérifiés par notre système.';
      el.innerHTML = '<span class="cm-rating__stars">' + stars + '</span>'
        + '<span class="cm-rating__value">' + note1(STORE_AVG) + '</span>'
        + '<span class="cm-rating__store-link">'
        +   '<a class="cm-rating__link" href="' + AVIS_URL + '">'
        +     avec(S.avisBoutique || '[n] avis boutique', '[n]', STORE_CNT)
        +   '</a>'
        +   '<button type="button" class="cm-rating__info" aria-label="' + (S.noteTransparenceAria || 'Note de transparence') + '">' + infoSvg + '</button>'
        + '</span>'
        + '<span class="cm-tp-tip" hidden>' + tipTxt + '</span>';
      var ibtn = el.querySelector('.cm-rating__info');
      var itip = el.querySelector('.cm-tp-tip');
      if (ibtn && itip) {
        ibtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); itip.hidden = !itip.hidden; });
        document.addEventListener('click', function (e) { if (!el.contains(e.target)) itip.hidden = true; });
      }
      syncStoreTrust();
    }
    titleBlock.parentNode.insertBefore(el, titleBlock);
    ancreDouce(el);
  }

  /* LA DOUCEUR DU SAUT, POSÉE SUR NOTRE SEUL LIEN, ET SUR RIEN D'AUTRE.
     ----------------------------------------------------------------------
     Une règle CSS `html { scroll-behavior: smooth }` ferait le même effet en
     une ligne, et c'est ce qui avait été écrit d'abord. Elle a été retirée le
     jour même : la propriété est GLOBALE, elle ne distingue pas une ancre d'un
     `window.scrollTo(0, y)`. Or une fiche en compte quatre, tous employés à
     RESTAURER la position après la libération d'un verrou de corps :
     `casemira-dropdown-size-picker.js` l.59 (fermeture du tiroir de taille) et
     l.306 (fermeture globale), `casemira-pdp-reskin.js` l.342 (guide des
     tailles), plus le popup et la barre du haut. Avec la règle globale, la page
     ne revient plus d'un coup à sa place : elle GLISSE, à chaque ouverture et
     fermeture du sélecteur de taille sur téléphone.

     Ici, l'écouteur ne vise que `.cm-rating__link[href^="#"]`, c'est-à-dire le
     lien « N avis produit » (le repli « avis boutique » pointe vers une autre
     page, son href ne commence pas par « # » et il n'est pas touché).
     `prefers-reduced-motion` coupe la douceur, jamais la navigation : dans ce
     cas on ne fait rien du tout et le `href` du HTML fait le saut sec.
     Si le JS ne tourne pas, le `href` fait le saut sec lui aussi. */
  function ancreDouce(scope) {
    var lien = scope.querySelector('.cm-rating__link[href^="#"]');
    if (!lien || lien.__cmAncre) return;
    lien.__cmAncre = true;
    lien.addEventListener('click', function (e) {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var cible = document.querySelector(lien.getAttribute('href'));
      if (!cible) return; /* pas de cible : on laisse le navigateur faire */
      e.preventDefault();
      cible.scrollIntoView({ behavior: 'smooth', block: 'start' });
      /* L'adresse doit garder l'ancre : partage, retour arrière, rechargement. */
      if (window.history && window.history.replaceState) {
        try { window.history.replaceState(null, '', lien.getAttribute('href')); } catch (err) {}
      }
    });
  }

  /* Masque le Trustpilot du BAS dès que la note BOUTIQUE est affichée en haut
     (fallback 0 avis produit). Re-joué à chaque applyAll → robuste même si le
     bloc Trustpilot du bas arrive dans le DOM après reviewRating(). */
  function syncStoreTrust() {
    /* L'avis boutique est-il affiché en haut (fallback 0 avis produit) ? */
    if (!document.querySelector('.section-main-product .cm-rating--store')) return;
    /* Oui → masque TOUS les Trustpilot « bar » de la page (même rendus hors
       .section-main-product : accordéons déplacés en colonne droite, jumeaux
       desktop/mobile…). `.ctb--bar` est spécifique à la fiche produit (le footer
       utilise .ctb--inline) → sûr de tout masquer. */
    document.querySelectorAll('.ctb.ctb--bar').forEach(function (bar) {
      var blk = bar.closest('.product__block') || bar;
      blk.style.setProperty('display', 'none', 'important');
    });
  }

  /* « Ajouter au panier · 89 € » : ajoute le prix courant au bouton (maquette) */
  function cartPrice() {
    var scope = document.querySelector('.section-main-product');
    if (!scope) return;
    var btn = scope.querySelector('.product-form__submit');
    if (!btn || btn.hasAttribute('disabled')) return;
    var txt = btn.querySelector('.btn__text');
    if (!txt || txt.querySelector('.cm-cart-price')) return;
    var priceEl = scope.querySelector('.product__block--price .f-price__sale .f-price-item--sale')
               || scope.querySelector('.product__block--price .f-price-item--regular');
    var price = priceEl ? priceEl.textContent.trim() : '';
    if (!price) return;
    txt.insertAdjacentHTML('beforeend', '<span class="cm-cart-sep">·</span><span class="cm-cart-price">' + price + '</span>');
  }

  /* C1 vague 3, point C5 : le séparateur « paiement express » a été SUPPRIMÉ.
     Le bouton d'achat express de Shopify (Apple Pay, PayPal, Shop Pay) reste
     tel que Shopify le sert ; il n'a jamais eu besoin d'être annoncé. Le lien
     « Plus de moyens de paiement » qui le suivait est rendu par Shopify
     lui-même (`.shopify-payment-button__more-options`) et n'existe dans aucun
     fichier du thème : il est masqué en CSS
     (assets/casemira-pdp-layout.css, section 5). */

  /* Accordéon Caractéristiques « entrouvert » : toujours ouvert mais réduit
     (.cm-peek) ; clic sur le résumé = déplie/replie l'aperçu, jamais fermé.
     On intercepte le clic en capture pour neutraliser le toggle du thème. */
  function caracPeek() {
    var d = document.querySelector('.section-main-product #Details-caracteristiques');
    if (!d || d.dataset.cmPeek) return;
    d.dataset.cmPeek = '1';
    d.setAttribute('open', '');
    d.classList.add('cm-peek');
    var sum = d.querySelector('summary');
    if (sum) {
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        d.classList.toggle('cm-peek');
        d.setAttribute('open', '');
      }, true);
    }
  }

  /* Barre de défilement CUSTOM persistante pour le dropdown dimensions
     (la native s'auto-masque sur mobile/iOS). Toujours visible quand la
     liste dépasse → l'utilisateur voit qu'il peut scroller vers le bas. */
  function dwScrollbar() {
    var scope = document.querySelector('.section-main-product') || document;
    scope.querySelectorAll('.dw-picker__scroll').forEach(function (sc) {
      var panel = sc.closest('.dw-picker__panel');
      if (!panel) return;
      if (!sc.dataset.cmBar) {
        sc.dataset.cmBar = '1';
        var bar = document.createElement('div'); bar.className = 'cm-dwbar';
        var thumb = document.createElement('div'); thumb.className = 'cm-dwbar__thumb';
        bar.appendChild(thumb); panel.appendChild(bar);
        var upd = function () {
          var sh = sc.scrollHeight, ch = sc.clientHeight;
          if (ch < 8 || sh <= ch + 2) { bar.classList.remove('is-on'); return; }
          bar.classList.add('is-on');
          bar.style.top = sc.offsetTop + 'px';
          bar.style.height = ch + 'px';
          var th = Math.max(30, ch * ch / sh);
          var top = (sh - ch) > 0 ? (sc.scrollTop / (sh - ch)) * (ch - th) : 0;
          thumb.style.height = th + 'px';
          thumb.style.transform = 'translateY(' + top + 'px)';
        };
        sc.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        var picker = sc.closest('.dw-picker');
        var trig = picker && picker.querySelector('.dw-picker__trigger');
        if (trig) trig.addEventListener('click', function () { setTimeout(upd, 60); setTimeout(upd, 380); });
        sc._cmUpd = upd;

        /* Drag du pouce (comme une vraie barre de scroll) */
        var dragY0 = 0, dragTop0 = 0;
        function onMove(e) {
          var ch = sc.clientHeight, sh = sc.scrollHeight;
          var th = Math.max(34, ch * ch / sh);
          var dy = (e.clientY || 0) - dragY0;
          var maxThumb = ch - th;
          if (maxThumb <= 0) return;
          var newTop = Math.min(maxThumb, Math.max(0, dragTop0 + dy));
          sc.scrollTop = (newTop / maxThumb) * (sh - ch);
        }
        function onUp() {
          document.removeEventListener('mousemove', onMove);
          document.removeEventListener('mouseup', onUp);
          document.body.style.userSelect = '';
        }
        thumb.addEventListener('mousedown', function (e) {
          e.preventDefault(); e.stopPropagation();
          dragY0 = e.clientY;
          dragTop0 = (parseFloat((thumb.style.transform.match(/translateY\(([-0-9.]+)px\)/) || [0, 0])[1])) || 0;
          document.body.style.userSelect = 'none';
          document.addEventListener('mousemove', onMove);
          document.addEventListener('mouseup', onUp);
        });
      }
      if (sc._cmUpd) sc._cmUpd();
    });
  }

  /* Format des dimensions : « 40 X 60 Cm » → « 40 × 60 cm ». Affichage seul :
     la sélection et le panier restent basés sur les vraies variantes
     (data-size-value, jamais réécrit).
     C1 vague 1 : les LIGNES gardent désormais leur « cm » (minuscule), comme le
     déclencheur. Le supprimer obligeait à le rajouter en CSS (::after), donc à
     laisser passer un « cm cm » le temps que ce script s'exécute. Le snippet
     rend déjà le « × » côté serveur : ici, il ne reste qu'un filet de sécurité
     pour les titres de variante au format inattendu. */
  function dwLabels() {
    var scope = document.querySelector('.section-main-product');
    if (!scope) return;
    scope.querySelectorAll('.dw-picker__row-dim').forEach(function (el) {
      var t = el.textContent;
      var f = t.replace(/(\d)\s*[xX]\s*(\d)/g, '$1 × $2').replace(/\s*cm\b/i, ' cm').trim();
      if (f && f !== t) el.textContent = f;
    });
    scope.querySelectorAll('.dw-picker__trigger-dim').forEach(function (el) {
      var t = el.textContent;
      var f = t.replace(/(\d)\s*[xX]\s*(\d)/g, '$1 × $2').replace(/\s*cm\b/i, ' cm').trim();
      if (f && f !== t) el.textContent = f;
    });
  }

  function applyAll(){ titleItalic(); addVizPill(); scarcity(); formeValue(); galleryDots(); reassurance(); trustBox(); hideDimAccordion(); priceFormat(); reviewRating(); cartPrice(); dwLabels(); syncStoreTrust(); }

  if (document.readyState !== 'loading') applyAll();
  document.addEventListener('DOMContentLoaded', applyAll);

  /* Prix du bouton : re-posé DANS LE MÊME TOUR D'ÉVÉNEMENT que le re-rendu
     de variante. product-info.js réécrit « Ajouter au panier » (sans prix)
     puis dispatche `variant:changed` de façon synchrone, juste après : en
     rejouant cartPrice() ici, le libellé complet est écrit avant le premier
     rendu du navigateur → une seule passe, pas d'état intermédiaire visible.
     (L'observer ci-dessous, débouncé à 80 ms + latence réseau, laissait sinon
     apparaître « Ajouter au panier » nu.) Les états « Épuisé »/« Indisponible »
     sont préservés : cartPrice() sort si le bouton est `disabled`. */
  document.addEventListener('variant:changed', function () {
    cartPrice();
    /* Même raison pour « Format : 120 × 170 cm » : product-info.js vient de
       remplacer le contenu du bloc prix, donc de l'effacer. On le repose tout
       de suite, pas 80 ms plus tard. */
    priceFormat();
  });

  /* C1 vague 1 : au franchissement de 768 px, la pastille change de parent
     (photo héros en desktop, conteneur du carrousel en mobile). */
  var vizDeb;
  window.addEventListener('resize', function () {
    clearTimeout(vizDeb);
    vizDeb = setTimeout(function () {
      addVizPill();
    }, 150);
  }, { passive: true });

  /* Réapplique après les re-rendus de la fiche (changement de variante…)

     ★ C1 VAGUE 10, point 2 : LA BOUCLE EST REFERMEE, DEUX FOIS.
     Cet observateur écoute `.section-main-product` et rappelle `applyAll()`,
     qui écrit DANS `.section-main-product`. Il s'entendait donc lui-même :
     mesuré le 22/08, page au repos, 5 s, iPhone 430, sur Sahel comme sur
     Valore : 120 mutations, soit un tour toutes les 82 ms, sans fin, sur
     chaque fiche produit ouverte. Douze fois par seconde, `formeValue()` et
     `priceFormat()` détruisaient et recréaient leurs nœuds, et les onze autres
     fonctions d'`applyAll()` relisaient le DOM pour rien.

     Deux verrous, parce qu'un seul se rouvre :
       1. les deux fonctions qui écrivaient sans condition comparent maintenant
          avant d'écrire (voir plus haut) ; les onze autres sortaient déjà tôt,
          chacune sur sa propre garde ;
       2. `takeRecords()` vide, juste après `applyAll()`, la file des mutations
          que `applyAll()` vient elle-même de produire. Même si une fonction
          future oubliait sa garde, elle ne pourrait plus se rappeler.
     Le prix, et il faut l'écrire : une mutation d'un AUTRE script tombant dans
     ce même tour est jetée avec les nôtres. Elle n'est jamais perdue longtemps,
     la mutation suivante rouvre le cycle, et `variant:changed` a de toute façon
     son propre chemin, synchrone, juste au-dessus. */
  var deb, host = document.querySelector('.section-main-product'), obsHost;
  if (window.MutationObserver && host) {
    obsHost = new MutationObserver(function () {
      clearTimeout(deb);
      deb = setTimeout(function () {
        applyAll();
        obsHost.takeRecords();
      }, 80);
    });
    obsHost.observe(host, { childList: true, subtree: true });
  }
})();
